var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"iDalgo-Button",class:{
    'disabled': _vm.disabled,
    'loading': _vm.loading
    },on:{"click":_vm.handleClick}},[_c('span',{staticClass:"iDalgo-Button__Content"},[_vm._t("default")],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"iDalgo-Button__Loader"},[_c('svgicon',{attrs:{"name":"loading","original":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ae11c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iDalgo-Button.vue
// module id = null
// module chunks = 